<template>
	<div>
		<v-progress-circular
			indeterminate
			color="primary"
			v-show="loading"
		/>
		<integrator-state-filters
			:loading="loading"
			@loadData="loadData"
			@startLoading="startLoading"
			@endLoading="endLoading"
		/>
		<v-data-table
			:items="data"
			:items-per-page="20"
			:headers="integratorToolHeaders"
			@click:row="handleClick"
		/>
		<v-dialog
			v-model="showPopup"
		>
			<v-card v-if="this.selectedRow" style="text-align: start">
				<v-row>
					<v-col cols="12" md="12" style="text-align: center; color: #49b3ff">
						<h4>Tip: To expand the whole json at once, Alt + Click on a property</h4>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" md="6">
						<h3>Document sent to FSS API: </h3>
						<json-viewer
							:value="selectedRow.entry"
							:expanded=true
							copyable
						/>
					</v-col>
					<v-col cols="12" md="6">
						<h3>Received Response from FSS API: </h3>
						<json-viewer
							:value="selectedRow.response"
							:expanded=true
							:expandDepth=10
							copyable
						/>
					</v-col>
				</v-row>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import axios from 'axios'
import JsonViewer from 'vue-json-viewer'
import IntegratorStateFilters from './IntegratorStateFilters.vue'

export default {
	name: 'IntegratorStateTool',
	components: { IntegratorStateFilters, JsonViewer },
	data() {
		return {
			loading: false,
			data: [],
			integratorToolHeaders: [
				{
					text: 'Notification ID',
					value: 'notification_id',
					width: 50,
					align: 'left',
				}, {
					text: 'Order ID',
					value: 'order_id',
					width: 50,
					align: 'left',
				}, {
					text: 'Item ID',
					value: 'item_id',
					width: 50,
					align: 'left',
				}, {
					text: 'Increment ID',
					value: 'increment_id',
					width: 80,
					align: 'left',
				}, {
					text: 'Refunded',
					value: 'order_refunded_flag',
					width: 50,
					align: 'left',
				}, {
					text: 'Document type',
					value: 'document_type',
					width: 100,
					align: 'left',
				}, {
					text: 'Received Response Message',
					value: 'received_response_message',
					width: 100,
					align: 'left',
				}, {
					text: 'Notification created at',
					value: 'notification_created_at',
					width: 120,
					align: 'left',
				}, {
					text: 'Notification updated at',
					value: 'notification_updated_at',
					width: 120,
					align: 'left',
				}, {
					text: 'Value sent at',
					value: 'sent_at',
					width: 120,
					align: 'left',
				}, {
					text: 'Job ID',
					value: 'job_id',
					width: 50,
					align: 'left',
				},
			],
			showPopup: false,
			selectedRow: null,
		}
	},
	methods: {
		async loadData(params) {
			try {
				this.loading = true
				const res = await axios.post(`${config.baseAPIurl}/integrator-state-tool/`, {
					params,
				})
				this.data = res.data
			} catch (error) {
				console.log(error)
			} finally {
				this.loading = false
			}
		},
		startLoading() { this.loading = true },
		endLoading() { this.loading = false },
		handleClick(row) {
			this.showPopup = true
			this.selectedRow = row
		},
	},
}
</script>

<style>

</style>
